module.exports = __webpack_public_path__ + "img/landing6.807b8ef3.webp";